import React, { useCallback, useContext, useState } from 'react'
import { AuthContext } from '@/layout/Auth'
import { Box } from '@mui/material'
import { OrderListWrapper } from '../components'
import { getOrderList } from '@/api'
import { useQuery } from '@tanstack/react-query'
import Order from './order'
import Pagination from '@/components/Pagination'

const OrderList: React.FC<unknown> = () => {
  const { authInfo } = useContext(AuthContext)
  const org_id = authInfo?.orgInfo?.id
  const [size, setSize] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState<number>(0)
  const queryList = useQuery(
    ['getOrderList', page, size],
    // @ts-ignore
    () => getOrderList({ page, size, org_id }),
    {
      onSuccess: (res) => {
        setTotal(res?.total)
      },
      enabled: !!org_id,
      refetchOnWindowFocus: true,
    },
  )

  const handleChangePage = useCallback((event: unknown, newPage: number) => {
    setPage(newPage)
  }, [])

  const handleChangeRowsPerPage = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSize(+event?.target?.value)
  }, [])

  return (
    <Box
      sx={{
        height: '100%',
        marginBottom: '24px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          height: '100%',
          flex: 1,
          overflow: 'auto',
          ...(navigator?.userAgent?.indexOf('Chrome') != -1 && {
            overflow: 'overlay',
          }),
        }}
      >
        <OrderListWrapper>
          {queryList?.isLoading
            ? [1, 2, 3].map((item) => (
                <Order
                  key={`order-${item}`}
                  // @ts-ignore
                  data={null}
                  loading={queryList?.isLoading}
                  // @ts-ignore
                  onCancel={null}
                />
              ))
            : queryList?.data?.detail?.map((order) => (
                <Order
                  key={`order-${order?.order_code}`}
                  data={order}
                  loading={false}
                  // @ts-ignore
                  onCancel={null}
                />
              ))}
        </OrderListWrapper>
      </Box>
      <Pagination
        sx={{ backgroundColor: 'transparent' }}
        count={total}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPageOptions={[10, 20, 50, 100]}
        rowsPerPage={size}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  )
}

export default OrderList
